import { Grid, IconButton, Tooltip, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { useEffect, useRef, useState } from "react";

const CommonDateRangePicker = ({
	handleDateRange,
}: {
	handleDateRange: (date: { start_date: string; end_date: string }) => void;
}) => {
	const [dateRange, setDateRange] = useState<{
		start_date: string;
		end_date: string;
	}>({
		start_date: "",
		end_date: dayjs().format("YYYY-MM-DD"),
	});

	const isInitialMount = useRef(true);

	useEffect(() => {
		if (isInitialMount.current) {
			isInitialMount.current = false;
			return;
		}

		if (dateRange?.start_date) {
			handleDateRange(dateRange);
		}
	}, [dateRange]);

	const handleClear = () => {
		setDateRange({
			start_date: "",
			end_date: dayjs().format("YYYY-MM-DD"),
		});
		handleDateRange({
			start_date: "",
			end_date: "",
		});
	};

	return (
		<Grid container alignContent={"center"} spacing={1}>
			<Grid item xs={12} sm={12} md={6}>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyItems: "center",
						columnGap: "5px",
					}}
				>
					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker
							sx={{ width: "100%" }}
							className='date_picker_custom'
							label='Start Date'
							format='DD/MM/YYYY'
							value={
								dateRange?.start_date
									? dayjs(dateRange?.start_date)
									: null
							}
							onChange={(e: any) =>
								setDateRange((prev) => ({
									...prev,
									start_date: e ? dayjs(e).format("YYYY-MM-DD") : "",
								}))
							}
							slotProps={{
								textField: { size: "small" },
							}}
						/>
					</LocalizationProvider>
				</Box>
			</Grid>
			<Grid item xs={12} sm={12} md={6}>
				<Box
					sx={{
						display: "flex",
						alignItems: "center",
						justifyItems: "center",
					}}
				>
					{dateRange?.start_date ? (
						<Tooltip title='Reset Date'>
							<IconButton
								size='small'
								onClick={handleClear}
								sx={{
									width: 28,
									height: 28,
									p: 0.5,
									color: "text.secondary",
									bgcolor: "action.hover",
									transition: "all 0.2s",
									"&:hover": {
										color: "error.main",
										bgcolor: "error.light",
									},
								}}
							>
								<CloseIcon sx={{ fontSize: 18 }} />
							</IconButton>
						</Tooltip>
					) : (
						<Typography
							fontWeight={"bold"}
							variant='h6'
							component='h6'
							gutterBottom
						>
							To
						</Typography>
					)}

					<LocalizationProvider dateAdapter={AdapterDayjs}>
						<DatePicker
							sx={{ width: "100%", marginLeft: "8px" }}
							className='date_picker_custom'
							label='End Date'
							format='DD/MM/YYYY'
							value={dateRange?.end_date ? dayjs(dateRange?.end_date) : null}
							onChange={(e: any) =>
								setDateRange((prev) => ({
									...prev,
									end_date: e ? dayjs(e).format("YYYY-MM-DD") : "",
								}))
							}
							slotProps={{
								textField: { size: "small" },
							}}
						/>
					</LocalizationProvider>
				</Box>
			</Grid>
		</Grid>
	);
};

export default CommonDateRangePicker;
